export default __webpack_public_path__ + "static/img_7369-5c51f1f68414254c9eb2558cffd5be82.jpg";